"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.iconSizesInPx = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("../../atoms/Icon"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var iconSizesInPx = {
  small: 10,
  "default": 16
};
exports.iconSizesInPx = iconSizesInPx;

var getIconFontSize = function getIconFontSize(_ref) {
  var fontSize = _ref.fontSize,
      typography = _ref.theme.typography;
  return (0, _styledComponents.css)(["font-size:", ";"], typography.pxToRem(iconSizesInPx[fontSize]));
};

var getIconCustomColor = function getIconCustomColor(_ref2) {
  var customColor = _ref2.customColor,
      buttonColor = _ref2.buttonColor,
      palette = _ref2.theme.palette;
  return (0, _styledComponents.css)(["color:", ";"], customColor || palette[buttonColor].contrastText);
};

var Icon = function Icon(_ref3) {
  var customColor = _ref3.customColor,
      buttonColor = _ref3.buttonColor,
      props = _objectWithoutProperties(_ref3, ["customColor", "buttonColor"]);

  return _react["default"].createElement(_Icon["default"], props);
};

var StyledIcon = /*#__PURE__*/(0, _styledComponents["default"])(Icon).withConfig({
  displayName: "Icon__StyledIcon"
})(["", " ", ""], getIconFontSize, getIconCustomColor);
StyledIcon.propTypes = {
  customColor: _propTypes["default"].string
};
var _default = StyledIcon;
exports["default"] = _default;